import React from 'react';
import PropTypes from 'prop-types';
import { mobileDetect } from 'rp-gui-guide';

const NameRow = ({ profile: {
    courseStyleName,
    courseClerk,
    courseTel,
} }) => (
    <div className="cp-nameRow">
        <h1 className="cp-nameRow__name">{courseStyleName}</h1>
        {courseClerk &&
            <div>
                Clerk of the course&nbsp;
                <span className="cp-nameRow__data">{courseClerk}</span>
            </div>
        }
        {courseTel &&
            <div>
                Racecourse contact&nbsp;
                {mobileDetect.isPhone() ? (
                    <a
                        href={`tel: ${courseTel}`}
                        className="ui-link cp-nameRow__data"
                    >
                        {courseTel}
                    </a>
                ) : (
                    <span className="cp-nameRow__data">
                        {courseTel}
                    </span>
                )}
            </div>
        }
    </div>
);

NameRow.propTypes = {
    profile: PropTypes.shape({
        courseStyleName: PropTypes.string.isRequired,
        courseClerk: PropTypes.string,
        courseTel: PropTypes.string,
    }).isRequired,
};

export default NameRow;



// WEBPACK FOOTER //
// ./src/js/course/nameRow/NameRow.jsx